<div class="col-md-12 noBottomMargin noPaddingMd-12 borderDiv mobileHeader">
  <div class="col-md-12" >
    <h2 class="changePasswordHeading">{{'global.form.forgotpassword' | translate}}</h2>
  </div>
  <div class="col-md-12 mainPasswordDiv">
    <div class="alert alert-success centerText" *ngIf="success">
      <strong>{{'global.form.activationsuccess' | translate}}</strong>
    </div>
    <div class="alert alert-danger centerText" *ngIf="error">
      <strong>{{'forgotpassword.messages.error.default' | translate}}</strong>
    </div>
    <div class="alert alert-danger centerText" *ngIf="errorERRFP000001">
      <strong>{{'forgotpassword.messages.error.ERRFP000001' | translate}}</strong>
    </div>
    <div class="alert alert-danger centerText" *ngIf="errorERRFP000002">
      <strong>{{'forgotpassword.messages.error.ERRFP000002' | translate}}</strong>
    </div>
    <div class="alert alert-danger centerText" *ngIf="errorERRFP000003">
      <strong>{{'forgotpassword.messages.error.ERRFP000003' | translate}}</strong>
    </div>
    <div class="alert alert-danger centerText" *ngIf="errorERRFP000004">
      <strong>{{'forgotpassword.messages.error.ERRFP000004' | translate}}</strong>
    </div>
    <div class="alert alert-danger centerText" *ngIf="errorERRFP000005">
      <strong>{{'forgotpassword.messages.error.ERRFP000005' | translate}}</strong>
    </div>
    <div class="col-md-12"></div>
    <form #passwordForm="ngForm" name="form" (submit)="forgotPassword()" >
      <div class="col-md-2 noPaddingMd-12">
      </div>
      <div class="col-md-4 ">
        <div class="login-form-group pmi_form_group">
          <input type="text"  id="username" name="username" ngControl="usernameCtrl" [(ngModel)]="username"
                 autocomplete="off" autofocus required>
          <span class="bar"></span>
          <label>{{'global.form.certificatenumber' | translate}}</label>
        </div>
      </div>
      <div class="col-md-4 noPaddingMd-12">
        <div class="login-form-group pmi_form_group">
          <input type="text" autocomplete="off"   [textMask]="{mask: mask ,guide:true ,keepCharPositions:true}"  (keyup)="updateDatePicker()" name="dateOfBirthText" [(ngModel)]="dateOfBirthText" autofocus required>
          <span class="bar"></span>
          <label>{{'global.form.dateofbirth' | translate}}</label>

        </div>
      </div>
      <div class="col-md-2 noPaddingMd-12">
        <my-date-picker  name="mydate"
                         [options]="myDatePickerOptions" (dateChanged)="onDateChanged($event)"
                         [(ngModel)]="dateOfBirth" required></my-date-picker>
      </div>

      <div class="col-md-12"></div>
      <div class="col-md-4 noPaddingMd-12"></div>
      <div class="col-md-4 btnDiv">
        <button type="submit"  class="btn btn-primary passBtn" [disabled]="!passwordForm.form.valid">{{'password.form.button' | translate}}</button>
      </div>
      <div class="col-md-12 noPaddingMd-12"></div>
      <div class="col-md-12 noPaddingMd-12"></div>
      <div class="col-md-12 noPaddingMd-12" [innerHtml]="'forgotpassword.info' | translate"></div>
    </form>
  </div>
</div>
